import './whatwedo.css';
import CommonList from '../common/CommonList';
import Meta from "../Meta";
import InnerPageHero from '../common/InnerPageHero';
import Catchment from '../../assets/images/catchment.png';
import LocationImage from '../../assets/images/location.png';
import ActivationImage from '../../assets/images/activation.png';
import BannerImage from '../../assets/images/whatwedo-banner.png';
import Whatwedo from "../home/hooks/Whatwedo";
import Contactform from '../home/hooks/Contactform';
export default function WhatWeDoPage() {
  const listCatchment = [
    {
      icon: 'fa-warehouse',
      title: 'You’re an existing company and planning your next big product launch.',
      description:
        'We will not only tell you where to set up shop—we’ll tell you exactly which neighbourhoods are ripe for the picking',
    },
    {
      icon: 'fa-map-marker-alt',
      title: 'You want to know where your customers are located.',
      description: 'We will not only tell you where they reside but also their numbers across specific neighbourhoods',
    },
    {
      icon: 'fa-store',
      title: 'You are planning to open new stores – and want the best locations for your concept.',
      description:
        'We will not only shortlist them but also give you revenue projections for the next 3 years',
    },
  ];
  const listLocation = [
    {
      icon: 'fa-cart-plus',
      title: 'Retailers',
      description:
        'Retailers incur recurring cost of operating an underperforming store – all because of a hasty location decision.',
    },
    {
      icon: 'fa-building',
      title: 'A premium mall',
      description: 'A premium mall is unable to attract tenants and footfalls – all because it is in the wrong part of the town',
    },
    {
      icon: 'fa-store',
      title: 'A franchisee',
      description:
        'A franchisee has co-opted with a large restaurant chain but footfalls and ATVs are low – He is left with nothing after paying the license fees',
    },
  ];
  const listActivation = [
    {
      icon: 'fa-shopping-basket',
      title: 'A retailer has limited influence on the desire of shoppers to come to that location.',
      description:
        'We’ll help you find ways to get more shoppers to choose your store and shoppers to shop at your store more',
    },
    {
      icon: 'fa-calculator',
      title: 'A retailer can control how fast inventory moves, how to upsell and cross sell products.',
      description: 'We can work with you to find innovative ways to close transactions, design promotions etc.',
    },
  ];

  return (
    <>
      <Meta title="What We Do" />
      <InnerPageHero title={"What We Do"} bgImage={BannerImage} />
      <div className="whatwedoInfo">
      <Whatwedo />
      </div>
      <section className="whatwedo-section">
        <div className="container">
            <h2>Driving Your <b>Business Success</b> Refining Your <b>Focus</b></h2>
            <div className="catchment-section">
          <div className="row g-sm-5">
            <div className="col-md-6">
             <figure><img className="pe-sm-5" src={Catchment} alt="" /></figure>
           </div>
            <div className="col-md-6">
            <h3 className='wwd-title'>On the Catchment</h3>
              <p className='wwd-subtitle'>Who the customers are, where they live and where they shop</p>
              {listCatchment.map((item, index) => (
                <CommonList
                  key={index}
                  title={item.title}
                  icon={item.icon}
                  description={item.description}
                />
              ))}
            </div>
          </div>
          </div>
        <div className="location-section">
          <div className="row flex-sm-row-reverse  g-sm-5">
            <div className="col-md-6 text-sm-end">
             <figure><img className="ps-sm-5" src={LocationImage} alt="" /></figure>
           </div>
            <div className="col-md-6">
            <h3 className='wwd-title'>On Location</h3>
              <p className='wwd-subtitle'>Saving you from a lifetime of sunk costs from wrong location decisions</p>
              {listLocation.map((item, index) => (
                <CommonList
                  key={index}
                  title={item.title}
                  icon={item.icon}
                  description={item.description}
                />
              ))}
            </div>
          </div>
      </div>
      <div className="activation-section">
          <div className="row g-sm-5">
            <div className="col-md-6">
             <figure><img className="pe-sm-5" src={ActivationImage} alt="" /></figure>
           </div>
            <div className="col-md-6">
            <h3 className='wwd-title'>On Activation</h3>
              <p className='wwd-subtitle'>Managing what is in your control</p>
              {listActivation.map((item, index) => (
                <CommonList
                  key={index}
                  title={item.title}
                  icon={item.icon}
                  description={item.description}
                />
              ))}
            </div>
        </div>
        </div>
        </div>
        </section>
        <Contactform />
    </>
  );
}
